/* DeoDap Diwali 2026 – mobile sidebar.
   Takes over the theme's ☰ menu button (header-drawer) below 990px and opens the Diwali sidebar instead. */
(function () {
  'use strict';
  if (window.__dwlDrawer) return;
  window.__dwlDrawer = true;
  var BP = 990;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    var root = document.querySelector('[data-dwl-drawer]');
    if (!root) return;
    if (root.parentElement !== document.body) document.body.appendChild(root); // escape header stacking contexts
    var drawer = root.querySelector('.dw-drawer'), scrim = root.querySelector('.dw-dr-scrim');
    var closeBtn = root.querySelector('.dw-dr-x'), acc = root.querySelector('.dw-dr-acc'), cats = root.querySelector('.dw-dr-cats');
    var opener = null, hideT;
    var isOpen = function () { return drawer.classList.contains('dw-open'); };

    function set(open) {
      drawer.classList.toggle('dw-open', open);
      drawer.setAttribute('aria-hidden', !open);
      drawer.inert = !open;
      document.body.classList.toggle('dwl-dr-lock', open);
      if (opener) opener.setAttribute('aria-expanded', open);
      clearTimeout(hideT);
      if (open) {
        scrim.hidden = false;
        requestAnimationFrame(function () { scrim.classList.add('dw-on'); });
        setTimeout(function () { closeBtn && closeBtn.focus({ preventScroll: true }); }, 60);
        startBelt();
      } else {
        scrim.classList.remove('dw-on');
        hideT = setTimeout(function () { if (!isOpen()) scrim.hidden = true; }, 320);
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      }
    }

    // take over the theme's menu button (capture phase, before the theme's own drawer handler)
    var MENU_SEL = 'header-drawer summary, summary.header__icon--menu, .header__icon--menu';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(MENU_SEL);
      if (!t || window.innerWidth >= BP) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var det = t.closest('details'); if (det) det.removeAttribute('open');
      opener = t;
      set(true);
    }, true);

    if (closeBtn) closeBtn.addEventListener('click', function () { set(false); });
    scrim.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) set(false); });
    drawer.addEventListener('click', function (e) { var a = e.target.closest('a[href*="#"]'); if (a) set(false); });
    if (acc && cats) acc.addEventListener('click', function () {
      var o = acc.getAttribute('aria-expanded') !== 'true';
      acc.setAttribute('aria-expanded', o); cats.hidden = !o;
    });
    var mq = window.matchMedia('(min-width: ' + BP + 'px)');
    var onMq = function (e) { if (e.matches && isOpen()) set(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

    // "Newly Launched" strip: smooth seamless auto-scroll (transform), drag to browse
    var rail = root.querySelector('.dw-dr-rail'), beltOn = false;
    function startBelt() {
      if (beltOn || !rail || rail.children.length < 2) return;
      beltOn = true;
      var items = Array.prototype.slice.call(rail.children);
      var inner = document.createElement('div'); inner.className = 'dw-dr-belt';
      items.forEach(function (c) { inner.appendChild(c); });
      items.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1'); inner.appendChild(k); });
      rail.appendChild(inner);
      var L = 0, x = 0, last = 0, hold = 0, drag = null, moved = false;
      var measure = function () { L = inner.children[items.length].offsetLeft - inner.children[0].offsetLeft; };
      var apply = function () { inner.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)'; };
      var norm = function () { if (L > 0) { while (x >= L) x -= L; while (x < 0) x += L; } };
      function tick(t) {
        if (!isOpen()) { last = 0; requestAnimationFrame(tick); return; }
        if (!L) measure();
        var dt = last ? Math.min(0.05, (t - last) / 1000) : 0; last = t;
        if (!drag && t > hold && !reduce) { x += 34 * dt; norm(); }
        apply(); requestAnimationFrame(tick);
      }
      rail.addEventListener('pointerdown', function (e) { drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x0: x, on: false }; moved = false; });
      rail.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
        if (!drag.on) { if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { drag.on = true; moved = true; try { rail.setPointerCapture(e.pointerId); } catch (err) {} } else if (Math.abs(dy) > 10) { drag = null; return; } else return; }
        x = drag.x0 - dx; apply();
      });
      var end = function () { if (!drag) return; drag = null; norm(); hold = performance.now() + 2200; };
      rail.addEventListener('pointerup', end); rail.addEventListener('pointercancel', end);
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      window.addEventListener('resize', measure);
      requestAnimationFrame(tick);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
